import { GetterTree } from 'vuex';
import { IAuthState, IRootStore } from '@/store/types';

export const getters: GetterTree<IAuthState, IRootStore> = {
  isUserLoggedIn: state => state.isLoggedIn,
};
